import React from "react";
import { ApplicationPermissionExtendedFlat } from "@src/Interfaces/Entity/ApplicationPermission";
import { Values } from "Tools/Values";
import { STPaper } from "@src/Components/Ui/STPaperOverflow";
import MaterialTable from "material-table";
import LinkIcon from "@material-ui/icons/Link";
import { STChip } from "./styles";
import { IdNameModel } from "@src/Stores/Values/types";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";

interface IProps {
  permissions: ApplicationPermissionExtendedFlat[];
}

export default class ApplicationPermissionsTable extends React.Component<IProps> {
  render() {
    return (
      <STPaper elevation={2}>
        <MaterialTable
          columns={[
            {
              title: Values.getLocalizationValue("application"),
              field: "applicationName",
              headerStyle: { color: "black", fontWeight: 600, fontSize: "0.8rem" },
              cellStyle: { color: "black", fontWeight: 400, fontSize: "0.8125rem", padding: "6px 24px 6px 16px" },
            },
            {
              title: Values.getLocalizationValue("organisation"),
              field: "organizationName",
              headerStyle: { color: "black", fontWeight: 600, fontSize: "0.8rem" },
              cellStyle: { color: "black", fontWeight: 400, fontSize: "0.8125rem", padding: "6px 24px 6px 16px" },
            },
            {
              title: Values.getLocalizationValue("template"),
              field: "entityName",
              headerStyle: { color: "black", fontWeight: 600, fontSize: "0.8rem" },
              cellStyle: { color: "black", fontWeight: 400, fontSize: "0.8125rem", padding: "6px 24px 6px 16px" },
            },
            {
              title: Values.getLocalizationValue("permission"),
              field: "permissionName",
              headerStyle: { color: "black", fontWeight: 600, fontSize: "0.8rem" },
              cellStyle: { color: "black", fontWeight: 400, fontSize: "0.8125rem", padding: "6px 24px 6px 16px" },
            },
            {
              title: Values.getLocalizationValue("positions"),
              field: "positionNames",
              headerStyle: { color: "black", fontWeight: 600, fontSize: "0.8rem" },
              sorting: false,
              cellStyle: { color: "black", fontWeight: 400, fontSize: "0.8125rem", padding: "6px 24px 6px 16px" },
              customFilterAndSearch: (filter, permission) =>
                Boolean(permission.positionNames.find((position) => String(position.name).match(filter))),
              render: (permission) => (
                <>
                  {permission.positionNames.map((position: IdNameModel, index: number) => {
                    return <STChip label={position.name} key={index} />;
                  })}
                </>
              ),
            },
            {
              title: Values.getLocalizationValue("positionTeams"),
              field: "positionTeamNames",
              headerStyle: { color: "black", fontWeight: 600, fontSize: "0.8rem" },
              sorting: false,
              cellStyle: { color: "black", fontWeight: 400, fontSize: "0.8125rem", padding: "6px 24px 6px 16px" },
              customFilterAndSearch: (filter, permission) =>
                Boolean(permission.positionTeamNames.find((positionTeam) => String(positionTeam.name).match(filter))),
              render: (permission) => (
                <>
                  {permission.positionTeamNames.map((positionTeam: IdNameModel, index: number) => {
                    return <STChip label={positionTeam.name} key={index} />;
                  })}
                </>
              ),
            },
            {
              title: "",
              field: "callbackUrl",
              headerStyle: { color: "black", fontWeight: 600, fontSize: "0.8rem" },
              sorting: false,
              filtering: false,
              cellStyle: {
                color: "black",
                fontWeight: 400,
                fontSize: "0.8125rem",
                padding: "6px 24px 6px 16px",
                textAlign: "center",
              },
              render: (permission) => (
                  <RoundButton
                      icon={<LinkIcon/>}
                      tooltipTitle={Values.getLocalizationValue("seeInApplication")}
                      onClick={() => window.open(permission.callbackUrl, "_blank")}
                  />
              ),
            },
          ]}
          data={this.props.permissions}
          options={{
            paging: false,
            search: false,
            showTitle: false,
            filtering: true,
            toolbar: false,
            draggable: false,
          }}
        />
      </STPaper>
    );
  }
}
